import ClusterA from './CluserA'

export default ClusterA
